var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRemoveFullscreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#434343;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,6C117.9,6,6,117.9,6,256s111.9,250,250,250s250-111.9,250-250S394.1,6,256,6z M256,492.5 C125.4,492.5,19.5,386.6,19.5,256S125.4,19.5,256,19.5S492.5,125.4,492.5,256S386.6,492.5,256,492.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M133.5,394l79.4-79.3v46.2c0,6,4.8,10.8,10.8,10.8c6,0,10.8-4.9,10.8-10.8v-72.3c0-6-4.8-10.8-10.8-10.8 h-72.3c-6,0-10.8,4.9-10.8,10.8s4.8,10.8,10.8,10.8h46.2l-79.4,79.3c-4.2,4.2-4.2,11.1,0,15.3C122.4,398.3,129.3,398.3,133.5,394z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M290.4,232.1h72.3c6,0,10.8-4.9,10.8-10.8c0-6-4.8-10.8-10.8-10.8h-46.2l77.2-77.1c4.2-4.2,4.2-11.1,0-15.3 c-2.1-2.1-4.9-3.2-7.7-3.2s-5.5,1.1-7.7,3.2l-77.2,77.1l0-46.2c0-6-4.8-10.8-10.8-10.8c-6,0-10.8,4.9-10.8,10.8v72.3 C279.6,227.2,284.4,232.1,290.4,232.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRemoveFullscreen);
export default __webpack_public_path__ + "static/media/icon-remove-fullscreen.0c567a3d3cf13ac2504c5bf38487a660.svg";
export { ForwardRef as ReactComponent };